import { useQuery } from '@tanstack/react-query';
import { useOrganisationFilter } from '@/features/organisations/providers/organisationHooks';
import { queryTagOptions, type TagOption } from '@/shared/data/tags';
import { useIsAuthenticated } from './auth';
import { queryKeys } from './queryKeys';
import type { ApiError } from '@/shared/data/client';
import type { UseQueryResult } from '@tanstack/react-query';

type UseTagOptionsParams = {
  projectId?: string | null;
  enabled?: boolean;
};

type UseTagOptionsResult = { tagOptions: TagOption[]; loading: boolean };

export const useTagOptions = ({
  projectId,
  enabled = true,
}: UseTagOptionsParams = {}): UseTagOptionsResult => {
  const isAuthenticated = useIsAuthenticated();
  const { selectedOrganisationId } = useOrganisationFilter();
  const orgKey = selectedOrganisationId ?? null;
  const tagOptionsQuery: UseQueryResult<TagOption[], ApiError> = useQuery<TagOption[], ApiError>({
    queryKey: queryKeys.tagOptions(projectId, orgKey),
    enabled: isAuthenticated && enabled,
    queryFn: async () =>
      await queryTagOptions({ projectId: projectId ?? null }, selectedOrganisationId ?? undefined),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    tagOptions: tagOptionsQuery.data ?? [],
    loading: tagOptionsQuery.isLoading,
  };
};
